import { boolean, number, array, string, object } from '@gogame/schemas';

import {
  PREPAID_EXPENSE_TYPE,
  PERIOD,
  AFFILIATE,
  APPLICATION,
  NETWORK,
  PLATFORM,
  CAMPAIGNS,
  AMOUNT,
  CURRENCY,
  ADJUSTMENT_REASON,
  TYPE,
} from './constants';

export const spendAdjustmentsSchema = object({
  [PREPAID_EXPENSE_TYPE]: boolean().default(false),
  [PERIOD]: array().required('Period is required'),
  [AFFILIATE]: number().required('Affiliate is required'),
  [APPLICATION]: number().required('Application is required'),
  [NETWORK]: number().required('Network is required'),
  [PLATFORM]: number(),
  [CAMPAIGNS]: array(),
  [AMOUNT]: number().required('Amount is required'),
  [CURRENCY]: string().required('Currency is required'),
});

export const validationSchema = spendAdjustmentsSchema.shape({
  [ADJUSTMENT_REASON]: number().required('Adjustment reason is required'),
  [TYPE]: number().required('Type is required'),
});

export const campaignsRequiredSchema = object({
  [AFFILIATE]: number().required('Affiliate is required'),
  [APPLICATION]: number().required('Application is required'),
  [NETWORK]: number().required('Network is required'),
  [PERIOD]: array().required('Period is required'),
});
